import React from 'react';

const DashboardPage = () => (
    <div className='content'>
    <img src='/images/Nestlarge.png'/>
  </div>
);

export default DashboardPage;



// WEBPACK FOOTER //
// ./src/components/DashboardPage.js